import { Button, Stack } from '@mui/material'
import type React from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { Header } from 'src/components/header/Header'
import { HeaderBackButtonMui } from 'src/components/header/HeaderBackButtonMui'
import { HeaderTitle } from 'src/components/header/HeaderTitle'
import LoadingOverlay from 'src/components/loading/LoadingOverlay'
import DataUnavailableWidget from 'src/features/dataUnavailableWidget/DataUnavailableWidget'
import { useDataUnavailableWidget } from 'src/features/dataUnavailableWidget/useDataUnavailableWidget'
import {
  getMultipleChoiceSet as getMultipleChoiceSetAction,
  resetMultipleChoiceSet as resetMultipleChoiceSetAction,
} from 'src/state/ducks/multipleChoiceSets/actions'
import type { RootState } from 'src/state/store'
import { useFormikProps } from './EditMultipleChoiceSet.hooks'
import ExcelConversionSettingsRow from './ExcelConversionSettingsRow'
import NameRow from './NameRow'
import OptionsRow from './OptionsRow'

const EditMultipleChoiceSetContainer: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { multipleChoiceSetId } = useParams<{ multipleChoiceSetId: string }>()

  const isLoading = useSelector(
    (state: RootState) =>
      state.multipleChoiceSetsState.multipleChoiceSet.isLoading,
  )

  const dataUnavailableWidget = useDataUnavailableWidget()

  const { formikProps, resetFormikProps } = useFormikProps(true)

  useEffect(() => {
    if (multipleChoiceSetId) {
      dispatch(getMultipleChoiceSetAction(multipleChoiceSetId))
    }

    return () => {
      dispatch(resetMultipleChoiceSetAction())
      resetFormikProps()
      dataUnavailableWidget.reset()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <LoadingOverlay tip="Loading" spinning={isLoading} size="large">
      <Header
        rightSlot={
          <Button
            variant="contained"
            onClick={() => formikProps.handleSubmit()}
          >
            保存
          </Button>
        }
      >
        <HeaderBackButtonMui
          onClick={() => history.push('/multipleChoiceSets')}
        />
        <HeaderTitle title="セット選択肢編集" />
      </Header>
      {dataUnavailableWidget.isVisible ? (
        <DataUnavailableWidget />
      ) : (
        <Stack
          spacing={2}
          py={4}
          px={2}
          sx={{ maxWidth: 1200, width: '100%', mx: 'auto' }}
        >
          <NameRow />
          <ExcelConversionSettingsRow />
          <OptionsRow />
        </Stack>
      )}
    </LoadingOverlay>
  )
}

export default EditMultipleChoiceSetContainer
